import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import Navbar from '../navbar';
import ReportNavbar from '../navbar/reportNavbar';
import SettingNavbar from '../navbar/settingNavbar';
import { CMDKOverLayDiv, Content, MainSection, SideBarListMain } from './styles';
import { VercelCMDK } from '../vercel';
import { useHotkeys } from 'react-hotkeys-hook';
import isEmpty from 'lodash/isEmpty';
import Responsivnavbar from '../navbar/responsiveNavbar';
import Modal from '../modals/modal';
import { isDev, isElectronApp, isIpad, isMediaRecordingSupported } from '../../helpers/common';
import SnapRecordModal from '../modals/snapRecordModal';
import { useMobileDevice } from '../../global/useMobile';
import { ContactUsModal } from '../modals/contactUsmodal';
import { SuccessFullModal } from '../modals/contactUsmodal/successfullModal';
import UserModal from '../modals/userModal';
import { captureException } from '../../services/logService';
import Avatar from '../avatar';
import { WorkspaceInterface } from '../../interfaces/WorkspaceInterface';
import { rootStore } from '../../mobx/rootStore';
import { setWorkspaceIdInAxios } from '../../helpers/authTokenHelpers';
import { workspaceSetAnalytics } from '../../services/analyticsService';
import UserPreferenceSingleton from '../../helpers/userPreferenceSingleton';
import { updateUserPreference } from '../../helpers/firebaseHelper';
import { clearPreviousWorkspaceData } from '../../services/baseServices';
import { appInit } from '../../services/appService';
import { observer } from 'mobx-react-lite';
import { AVATAR_BORDER, DESKTOP_VIEW, TABS_COMMAND_K_ID } from '../../global/constants';
import CreateTaskModalV2 from '../modals/createTaskModal';
import WorkSpaceLoading from '../loading/workSpaceLoading';
import { loadInboxData } from '../../services/inboxServices';
import { convertQueryToWordsCollection } from '../../services/universalSearch';
import { toJS } from 'mobx';
import Image from '../image';
import { ROUTES } from '../../routes/urls';
declare global {
  interface Window {
    posthog?: {
      group: (type: string, id: string, properties: Record<string, unknown>) => void;
    };
  }
}

interface Props {
  children?: React.ReactNode;
  isInbox?: boolean;
  isPosition?: boolean;
  isMessageBox?: boolean;
  isTaskDetailPreviewOpen?: boolean;
  isOverflowHidden?: boolean;
}

const AppLayout: React.FC<Props> = (Props) => {
  const {
    isInbox = false,
    children,
    isPosition = false,
    isMessageBox = false,
    isTaskDetailPreviewOpen = false,
    isOverflowHidden = false
  } = Props;
  //States
  const [searchBox, setSearchBox] = useState(false);
  const [isOpenSnapModal, setIsOpenSnapModal] = useState(false);
  const [isOpenTaskModal, setIsOpenTaskModal] = useState(false);
  const [openContactUsModal, setOpenContactUsModal] = useState(false);
  const [isSuccessfulModalOpen, setIsSuccessfulModalOpen] = useState(false);
  const [isOpenUserModal, setIsOpenUserModal] = useState(false);
  // const [activeWorkspace, setActiveWorkspace] = useState<string | null>(null);

  // Mobx store
  const { appStore, workspaceStore } = rootStore || {};
  const { extractedDesktopView, isAppLoading, isNavbarShow, isTabBarLoad } = appStore || {};
  const { currentWorkspace, workspaceList } = workspaceStore || {};
  //other variables
  const isMobile = useMobileDevice();
  const location = useLocation();
  const history = useHistory();

  // useEffect(() => {
  //   const handleScroll = (event: Event) => {
  //     const target = event.target as HTMLElement;
  //     const isScrolled = target.scrollTop > 15;
  //     rootStore.appStore.setIsPageScrolled(isScrolled);
  //   };

  //   // Function to add scroll listeners to all scrollable elements
  //   const addScrollListeners = () => {
  //     const scrollableElements = document.querySelectorAll('*');
  //     scrollableElements.forEach((element) => {
  //       if (
  //         element instanceof HTMLElement &&
  //         (element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth)
  //       ) {
  //         element.addEventListener('scroll', handleScroll);
  //       }
  //     });
  //   };

  //   // Initial setup
  //   addScrollListeners();

  //   // Set up MutationObserver to detect new elements
  //   const observer = new MutationObserver((mutations) => {
  //     mutations.forEach((mutation) => {
  //       if (mutation.addedNodes.length) {
  //         addScrollListeners();
  //       }
  //     });
  //   });

  //   // Start observing the document body for changes
  //   observer.observe(document.body, {
  //     childList: true,
  //     subtree: true
  //   });

  //   return () => {
  //     // Clean up scroll listeners
  //     const scrollableElements = document.querySelectorAll('*');
  //     scrollableElements.forEach((element) => {
  //       if (element instanceof HTMLElement) {
  //         element.removeEventListener('scroll', handleScroll);
  //       }
  //     });
  //     // Disconnect the observer
  //     observer.disconnect();
  //   };
  // }, []);

  useEffect(() => {
    rootStore.appStore.setIsPageScrolled(false);
  }, [location.pathname]);

  const getActiveProjectId = useCallback((): string | undefined => {
    const projectMatch = location.pathname.match(/\/projects\/details\/([^/]+)/);
    if (projectMatch) return projectMatch[1];
    return undefined;
  }, [location.pathname]);

  useHotkeys(['ctrl+k', 'meta+k'], async (event) => {
    event.preventDefault();
    const activeProjectId = getActiveProjectId();
    const { projects, tasks, users } = convertQueryToWordsCollection('', TABS_COMMAND_K_ID.ALL, activeProjectId);
    rootStore.appStore.setUniversalSearchData({ projects, tasks, users });
    setSearchBox(true);
  });
  useHotkeys('esc', async (event) => {
    event.preventDefault();
    setSearchBox(false);
  });

  const closeCmdPopup = useCallback(() => {
    if (!isMobile) {
      setSearchBox(false);
    }
  }, [isMobile]);

  const handleOverlayClick = useCallback(
    (e: React.MouseEvent<HTMLDivElement>) => {
      if (isMobile) {
        return;
      }
      const target = e.target as HTMLElement;
      if (!isEmpty(target.className)) {
        setSearchBox(false);
      } else {
        setSearchBox(true);
      }
    },
    [isMobile]
  );

  const onClickCreateTask = useCallback(() => {
    setIsOpenTaskModal(true);
  }, []);

  const openSnapModal = useCallback(() => {
    setIsOpenSnapModal(true);
  }, []);

  const closeSnapModal = useCallback(() => {
    setIsOpenSnapModal(false);
  }, []);

  const closeTaskModal = useCallback(() => {
    setIsOpenTaskModal(false);
  }, []);

  const onCloseContactUsModal = useCallback(() => {
    setOpenContactUsModal(false);
  }, []);

  const onCloseSuccessfullModal = useCallback(() => {
    setIsSuccessfulModalOpen(false);
  }, []);

  const onClickUserPopup = useCallback(() => {
    setIsOpenUserModal(true);
  }, []);

  const onCloseUserModal = useCallback(() => {
    setIsOpenUserModal(false);
  }, []);

  const renderCmdBox = useMemo(() => {
    const isVercelModalOpen = searchBox;
    return (
      isVercelModalOpen && (
        <>
          <CMDKOverLayDiv role='button' onClick={handleOverlayClick} />
          <VercelCMDK
            openSnapModal={openSnapModal}
            closePopup={closeCmdPopup}
            openTaskModal={onClickCreateTask}
            openUserModal={onClickUserPopup}
            setOpenContactUsModal={() => setOpenContactUsModal(!openContactUsModal)}
            initialFilterProjectId={getActiveProjectId()}
          />
        </>
      )
    );
  }, [
    closeCmdPopup,
    getActiveProjectId,
    handleOverlayClick,
    onClickCreateTask,
    onClickUserPopup,
    openContactUsModal,
    openSnapModal,
    searchBox
  ]);

  const renderNavbar = useCallback(() => {
    if (location.pathname.startsWith('/settings')) {
      if (!isMobile && isNavbarShow) {
        return <SettingNavbar />;
      }
    } else if (location.pathname.startsWith('/report')) {
      if (!isMobile && isNavbarShow) {
        return <ReportNavbar />;
      }
    } else {
      return (
        <>
          {isNavbarShow && (
            <nav className='webview'>
              <Navbar setOpenContactUsModal={() => setOpenContactUsModal(!openContactUsModal)} />
            </nav>
          )}

          <div className='mobileView'>
            {!location.pathname.startsWith('/projects') &&
            location.pathname !== '/' &&
            !location.pathname.startsWith('/messages') &&
            !location.pathname.startsWith('/timeTracking') &&
            !location.pathname.startsWith('/customer') &&
            !location.pathname.startsWith('/my-tasks') &&
            !location.pathname.startsWith('/search') &&
            !location.pathname.startsWith('/recurring-tasks') &&
            !location.pathname.startsWith('/invoices') &&
            !location.pathname.startsWith('/home') &&
            !location.pathname.startsWith('/snap') &&
            !location.pathname.startsWith('/views') &&
            !location.pathname.includes('/view/') &&
            !location.pathname.startsWith('/members') ? (
              <Responsivnavbar />
            ) : (
              ''
            )}
          </div>
        </>
      );
    }
  }, [isMobile, isNavbarShow, location.pathname, openContactUsModal]);

  const selectWorkspace = useCallback(
    async (item: WorkspaceInterface) => {
      try {
        // setLoading(true);
        if (!item?.id || item?.id === currentWorkspace?.id) return;
        rootStore.appStore.setIsAppLoading(true);
        // const tabStore = rootStore.workspaceStore.workspaces.find((workspace) => workspace.id===item?.id)?.tabsStore;
        // const ref = tabStore?.tabs.find((tab) => tab.id === tabStore?.selectedTabId);
        // history.push(ref?.path || '/');

        setWorkspaceIdInAxios(item?.id);
        workspaceSetAnalytics(item?.id);
        await UserPreferenceSingleton.getInstance().setWorkspace(toJS(item));
        if (!isDev()) await updateUserPreference({ current_workspace_id: item?.id });
        const clearResult = await clearPreviousWorkspaceData();
        const initResult = await appInit(false, true);
        loadInboxData();
        const intercomPayload = {
          company: {
            name: item?.name,
            id: item?.id
          }
        };
        if (window?.posthog) {
          window.posthog.group('Workspace', intercomPayload.company?.id, {
            name: intercomPayload.company?.name
          });
        }
        if (clearResult && initResult) {
          UserPreferenceSingleton.getInstance().setRecentSearch([]);
          history.push(ROUTES.INBOX);
        }
      } catch (e) {
        captureException(e);
      } finally {
        rootStore.appStore.setIsAppLoading(false);
        // setLoading(false);
      }
    },
    [currentWorkspace?.id, history]
  );

  const renderElectronSidebar = useMemo(() => {
    return (
      <SideBarListMain
        disabled={isAppLoading}
        className={isNavbarShow ? 'electron-sidebar' : 'electron-sidebar navbar-hidden'}>
        {workspaceList?.map((workspace) => (
          <div
            role='button'
            key={workspace.id}
            className={`workspace-logo ${currentWorkspace?.id === workspace.id ? 'active' : ''}`}
            onClick={() => selectWorkspace(workspace)}>
            {!isEmpty(workspace?.logoUrl) ? (
              <Image
                src={workspace?.logoUrl}
                alt='profilePhoto'
                width={32}
                height={32}
                borderRadius=' var(--border-radius-8)'
                objectFit='cover'
              />
            ) : (
              <Avatar
                imgSrc={workspace?.logoUrl || ''}
                name={workspace?.name}
                size={32}
                borderVariant={AVATAR_BORDER.NONE}
                borderRadius='var(--border-radius-8)'
              />
            )}
          </div>
        ))}
      </SideBarListMain>
    );
  }, [isAppLoading, currentWorkspace?.id, isNavbarShow, workspaceList, selectWorkspace]);

  const mainSectionClassName = useMemo(() => {
    return [
      'main-section',
      !isNavbarShow && extractedDesktopView && 'navbar-extracted-hidden',
      extractedDesktopView ? 'extracted-desktop-diff-padding' : 'extracted-desktop-hidden',
      !isNavbarShow ? 'main-navbar-hidden' : 'main-navbar-show',
      !isTabBarLoad && 'tabbar-not-load'
    ]
      .filter(Boolean)
      .join(' ');
  }, [isNavbarShow, extractedDesktopView, isTabBarLoad]);

  return (
    <MainSection
      isInbox={isInbox}
      isMessageBox={isMessageBox}
      isTaskDetailPreviewOpen={isTaskDetailPreviewOpen}
      className={mainSectionClassName}>
      {isElectronApp() && extractedDesktopView === DESKTOP_VIEW.OPEN && renderElectronSidebar}
      {renderCmdBox}
      {isAppLoading ? (
        <WorkSpaceLoading />
      ) : (
        <>
          {renderNavbar()}
          <Content
            isPosition={isPosition}
            isOverflowHidden={isOverflowHidden}
            className={`right-content ${!isNavbarShow ? 'navbar-hidden' : ''}`}
            style={
              isIpad()
                ? {
                    borderRadius: isNavbarShow
                      ? '8px 8px var(--ipad-border-radius) 8px'
                      : '8px 8px var(--ipad-border-radius) var(--ipad-border-radius)'
                  }
                : {}
            }>
            {children}
          </Content>
        </>
      )}
      <Modal open={isOpenTaskModal} onClose={closeTaskModal} maxWidth={'680px'} isCreateTask={true}>
        <CreateTaskModalV2 onCancel={closeTaskModal} context={{ source: 'shortcut' }} />
      </Modal>
      {isMediaRecordingSupported() && (
        <Modal open={isOpenSnapModal} onClose={closeSnapModal} maxWidth={'258px'}>
          <SnapRecordModal handleCloseModal={closeSnapModal} />
        </Modal>
      )}
      {/* contact us Modal */}
      <Modal open={openContactUsModal} onClose={onCloseContactUsModal} maxWidth={'500px'}>
        <ContactUsModal
          openSuccessFullModal={() => setIsSuccessfulModalOpen(true)}
          closeContactUsModal={() => setOpenContactUsModal(false)}
        />
      </Modal>
      <Modal open={isSuccessfulModalOpen} onClose={onCloseSuccessfullModal} maxWidth={'500px'}>
        <SuccessFullModal onClose={onCloseSuccessfullModal} />
      </Modal>
      <Modal open={isOpenUserModal} onClose={onCloseUserModal} maxWidth={'280px'}>
        <UserModal onClose={onCloseUserModal} />
      </Modal>
    </MainSection>
  );
};

export default observer(AppLayout);
